import cachedFirestore from "./cachedFirestore";
import {
  drawLevels,
  levelSnapshotsToLevels,
  renderPlaceholderFeeds,
} from "./community/feed";
import { catchErrorWithStack } from "./crashlytics";
import {
  communityNavEl,
  profileAboutMeEl,
  profileBackBtnEl,
  profileBtnEl,
  profileContainerEl,
  profileFeedEl,
  profileLevelsCreatedCounterEl,
  profileLevelsWonCounterEl,
  profileNameEl,
  profilePhotoEl,
  profileSocialEl,
  profileStoryModeCounterEl,
  profileUnameEl,
} from "./elements";
import { addTouchEvent, removeAllTouchEvents } from "./events";
import { stack } from "./nav";
import { showProfileEditor } from "./profileEditor";
import { addClickToBtns } from "./sound";
import { withSpinner } from "./spinner";
import store from "./store";
import { formatNumber } from "./utils";
import { updateStyles } from "./nav/styles";
import { yieldWithPriority } from "./promise";
import { IS_WEB } from "./config";
import { autoTranslate, resetLangAttributeOfLeafs } from "./translate";

let currentUidGlob = null;

export async function showProfile(uid) {
  if (!uid) uid = store.user.uid;
  stack.push("profile", { uid });
  currentUidGlob = uid;
  await refreshProfile(uid);
  updateStyles();
}

export async function refreshProfile(uid) {
  if (!uid) uid = currentUidGlob;
  if (!uid) return;
  const data = await cachedFirestore.getDocument({
    reference: `profile/${uid}`,
    defaultData: uid === store.user.uid ? store.profile : {},
  });
  data.uid = uid;
  await updateProfile(data);
  updateScrollPositionProfile();
}

export async function updateProfile(profile) {
  profileUnameEl.textContent = profile.uname;
  profileNameEl.textContent = profile.name;
  profileAboutMeEl.textContent = profile.aboutme;
  profilePhotoEl.src = profile.thumbnailUrl || "img/placeholder.jpg";
  profileStoryModeCounterEl.textContent = formatNumber(
    profile.storyLevelIdx || 0
  );
  profileLevelsWonCounterEl.textContent = formatNumber(
    profile.levelsWonCount || 0
  );
  //     profile.followersCount || 0
  //   );
  //   profileFollowingCounterEl.textContent = formatNumber(
  //     profile.followingCount || 0
  //   );
  profileLevelsCreatedCounterEl.textContent = formatNumber(
    profile.levelsCreatedCount || 0
  );

  if (profile.uid === store.user.uid) {
    profileBtnEl.classList.remove(
      "profile-button-follow",
      "profile-button-unfollow"
    );
    profileBtnEl.classList.add("profile-button-edit-profile");
    profileBtnEl.textContent = "Edit profile";
    resetLangAttributeOfLeafs(profileBtnEl)
    profileBtnEl.style.display = null;
    removeAllTouchEvents(profileBtnEl);
    addTouchEvent(profileBtnEl, () => showProfileEditor());
  } else {
    // const following = await isFollowedBy(profile.uid, store.user.uid);
    profileBtnEl.style.display = "none";
    // if (following) {
    //   profileBtnEl.classList.remove(
    //     "profile-button-edit-profile",
    //     "profile-button-follow"
    //   );
    //   profileBtnEl.classList.add("profile-button-unfollow");
    //   profileBtnEl.textContent = "Unfollow";
    //   removeAllTouchEvents(profileBtnEl);
    //   addTouchEvent(profileBtnEl, () => withSpinner(unfollow(profile)));
    // } else {
    //   profileBtnEl.classList.remove(
    //     "profile-button-edit-profile",
    //     "profile-button-unfollow"
    //   );
    //   profileBtnEl.classList.add("profile-button-follow");
    //   profileBtnEl.textContent = "Follow";
    //   removeAllTouchEvents(profileBtnEl);
    //   addTouchEvent(profileBtnEl, () => withSpinner(follow(profile)));
    // }
  }
  await withSpinner(showFeed(profile.uid, profileFeedEl));
  communityNavEl.style.transform = null;
  profileBackBtnEl.style.backgroundColor = null;
  profileBackBtnEl.querySelector(
    ".material-symbols-outlined"
  ).style.textShadow = null;
  profileBackBtnEl.style.backgroundColor = null;
  profileUnameEl.style.textShadow = null;
  profileUnameEl.style.top = null;
  profileBackBtnEl.style.top = null;

  const tiktokBtnEl = profileSocialEl.querySelector(".tiktok");
  const igBtnEl = profileSocialEl.querySelector(".ig");
  const discordBtnEl = profileSocialEl.querySelector(".discord");
  const redditBtnEl = profileSocialEl.querySelector(".reddit");
  if (profile.tiktok) {
    tiktokBtnEl.style.display = null;
    removeAllTouchEvents(tiktokBtnEl);
    addTouchEvent(tiktokBtnEl, () => {
      window.open(`https://www.tiktok.com/@${profile.tiktok}`);
    });
  } else tiktokBtnEl.style.display = "none";
  if (profile.ig) {
    igBtnEl.style.display = null;
    removeAllTouchEvents(igBtnEl);
    addTouchEvent(igBtnEl, () => {
      window.open(`https://www.instagram.com/${profile.ig}`);
    });
  } else igBtnEl.style.display = "none";
  if (profile.discord) {
    discordBtnEl.style.display = null;
    removeAllTouchEvents(discordBtnEl);
    addTouchEvent(discordBtnEl, () => {
      window.open(`https://discord.com/users/${profile.discord}`);
    });
  } else discordBtnEl.style.display = "none";
  if (profile.reddit) {
    redditBtnEl.style.display = null;
    removeAllTouchEvents(redditBtnEl);
    addTouchEvent(redditBtnEl, () => {
      window.open(`https://www.reddit.com/user/${profile.reddit}`);
    });
  } else redditBtnEl.style.display = "none";
  await yieldWithPriority("user-visible");
  autoTranslate();
  addClickToBtns();
}

// showProfile()

addTouchEvent(profileBackBtnEl, () => {
  stack.pop();
  updateStyles();
});

const NUM_COLUMNS_INIT = 10;
const NUM_ROWS = 1;
const NUM_COLUMNS_SCROLL = 10;
let numColsRenderedGlob = 0;
let lastVisibleGlob = null;
let feedGlob = [];
let timeoutGlob = null;
let lastScrollPositionGlob = 0;
let handlingScrollGlob = false;
let uidGlob;

export function updateScrollPositionProfile() {
  //   const startPosition = -profileFeedEl.scrollLeft - 0.742 * store.innerHeight;
  const startPosition = -profileFeedEl.scrollLeft + 0.12 * store.innerHeight;

  // Check if the first element has reached the navigation bar
  if (startPosition < 0) {
    // Apply scrolling effect
    // Example: Move the navigation to the left
    profileContainerEl.style.transform = "translateX(" + startPosition + "px)";
    const profileContainerElWidth = store.innerHeight * 0.8;
    const alpha = Math.max(
      0,
      (profileContainerElWidth + startPosition) / profileContainerElWidth
    );
    profileBackBtnEl.style.backgroundColor = `rgba(211,211,211,${alpha}`;
    profileBackBtnEl.style.boxShadow = `0 0.6vmin 0.9vmin rgba(0, 0, 0, ${
      alpha * 0.6
    })`;
    const iconEl = profileBackBtnEl.querySelector(".material-symbols-outlined");
    const textShadow = `rgba(255, 255, 255, ${1 - alpha}) 0 0 2vmin`;
    iconEl.style.textShadow = textShadow;
    profileUnameEl.style.textShadow = textShadow;
    profileUnameEl.style.top = `${5 - (1 - alpha) * 3}vmin`;
    profileBackBtnEl.style.top = `${4 - (1 - alpha) * 3}vmin`;
  } else {
    // Reset the navigation position
    profileContainerEl.style.transform = null;
    profileBackBtnEl.style.backgroundColor = null;
    profileUnameEl.style.textShadow = null;
    profileUnameEl.style.top = null;
    profileBackBtnEl.style.top = null;
    profileBackBtnEl.style.boxShadow = null;
  }
}

async function _scrollCallback(currentScroll, totalWidth) {
  if (currentScroll >= totalWidth - 2 && !handlingScrollGlob) {
    handlingScrollGlob = true;
    lastScrollPositionGlob = currentScroll;
    const start = numColsRenderedGlob * NUM_ROWS;
    const end = (numColsRenderedGlob + NUM_COLUMNS_SCROLL) * NUM_ROWS;
    let feed = feedGlob.slice(start, end);
    if (!feed.length) feedGlob = await withSpinner(fetchFeeds(uidGlob, true));
    feed = feedGlob.slice(start, end);
    const numNewCols = Math.min(
      Math.ceil(feed.length / NUM_ROWS),
      NUM_COLUMNS_SCROLL
    );
    renderPlaceholderFeeds(
      profileFeedEl,
      numNewCols,
      numColsRenderedGlob,
      "community-feed-profile"
    );
    drawLevels({
      feedEl: profileFeedEl,
      feed,
      offSet: numColsRenderedGlob,
      showFeed,
      screenNamePrev: "profile",
      idPreffix: "community-feed-profile",
    });
    numColsRenderedGlob += numNewCols;
    handlingScrollGlob = false;
  }
}

function scrollCallback() {
  if (store.screenName !== "profile") return;

  const totalWidth = profileFeedEl.scrollWidth;
  const currentScroll = profileFeedEl.scrollLeft + profileFeedEl.clientWidth;

  if (currentScroll !== lastScrollPositionGlob) {
    if (timeoutGlob) clearTimeout(timeoutGlob);
    timeoutGlob = setTimeout(_scrollCallback, 100, currentScroll, totalWidth); // Adjust the timeout as needed
  }

  updateScrollPositionProfile();
}

async function showFeed(uid) {
  uidGlob = uid;
  numColsRenderedGlob = 0;
  lastVisibleGlob = null;
  profileFeedEl.innerHTML = "";

  profileFeedEl.removeEventListener("scroll", scrollCallback);

  feedGlob = await fetchFeeds(uid);
  const feed = feedGlob.slice(0, NUM_COLUMNS_INIT * NUM_ROWS);
  renderPlaceholderFeeds(
    profileFeedEl,
    Math.min(feed.length, NUM_COLUMNS_INIT),
    0,
    "community-feed-profile"
  );
  drawLevels({
    feedEl: profileFeedEl,
    feed,
    showFeed,
    screenNamePrev: "profile",
    idPreffix: "community-feed-profile",
  });
  numColsRenderedGlob += NUM_COLUMNS_INIT;

  timeoutGlob = null;
  lastScrollPositionGlob = 0;

  profileFeedEl.addEventListener("scroll", scrollCallback);
}

async function fetchFeeds(uid, append = false) {
  try {
    const queryConstraints = [
      {
        type: "limit",
        limit:
          (lastVisibleGlob ? NUM_COLUMNS_SCROLL : NUM_COLUMNS_INIT) * NUM_ROWS,
      },
      {
        type: "orderBy",
        fieldPath: "createdAt",
        directionStr: "desc",
      },
    ];
    const compositeFilter = {
      type: "and",
      queryConstraints: [
        {
          type: "where",
          fieldPath: "creatorId",
          opStr: "==",
          value: uid,
        },
      ],
    };
    if (uid !== store.user.uid && IS_WEB && !__ADMIN__)
      // TODO: add this to Android when it supports multiple composite filters
      compositeFilter.queryConstraints.push({
        type: "where",
        fieldPath: "isPublic",
        opStr: "==",
        value: true,
      });
    if (lastVisibleGlob)
      queryConstraints.push({
        type: "startAfter",
        reference: lastVisibleGlob.path,
      });
    let snapshots = await cachedFirestore.getCollection({
      reference: "communityLevels",
      queryConstraints,
      compositeFilter,
      defaultData: [],
    });
    if (!IS_WEB && uid !== store.user.uid && !__ADMIN__) {
      // TODO: remove this when Android supports multiple composite filters
      snapshots = snapshots.filter(({ data }) => data.isPublic);
    }
    if (!snapshots.length) {
      if (uid === store.user.uid) return store.communityLevelsUser;
      return [];
    }
    lastVisibleGlob = snapshots[snapshots.length - 1];
    let levels = levelSnapshotsToLevels(snapshots);
    if (append) levels = [...feedGlob, ...levels];
    if (uid === store.user.uid) store.set("communityLevelsUser", levels);
    return levels;
  } catch (error) {
    catchErrorWithStack(error);
  }
  feedGlob;
}

export async function setStoryLevelIdx(idx) {
  if (store.user.uid)
    cachedFirestore.updateDocument({
      reference: `profile/${store.user.uid}`,
      data: {
        storyLevelIdx: idx,
      },
    });
  store.profile.storyLevelIdx = idx;
  store.save("profile");
}

// export async function follow(profile) {
//   console.debug(
//     `Following ${profile.uid} (current followers: ${currentFollowersCount})`
//   );
//   await cachedFirestore.setDocument({
//     reference: `profile/${profile.uid}/followers/${store.user.uid}`,
//     data: {
//       uid: store.user.uid,
//       thumbnailUrl: store.profile.thumbnailUrl,
//       name: store.profile.name,
//       timestamp: Date.now(),
//     },
//     throwOnError: true,
//   });
//   await cachedFirestore.setDocument({
//     reference: `profile/${store.user.uid}/following/${profile.uid}`,
//     data: {
//       uid: profile.uid,
//       thumbnailUrl: profile.thumbnailUrl,
//       name: profile.name,
//       timestamp: Date.now(),
//     },
//     throwOnError: true,
//   });
//   store.profile.followingCount += 1;
//   store.save("profile");
//   cachedFirestore.clearCollectionCache(`profile/${store.user.uid}/following`);
//   cachedFirestore.clearCollectionCache("communityLevels");
//   await refreshProfile();
// }

// export async function unfollow(profile) {
//   console.debug(
//     `Unfollowing ${profile.uid} (current followers: ${currentFollowersCount})`
//   );
//   await cachedFirestore.deleteDocument({
//     reference: `profile/${profile.uid}/followers/${store.user.uid}`,
//     throwOnError: true,
//   });
//   await cachedFirestore.deleteDocument({
//     reference: `profile/${store.user.uid}/following/${profile.uid}`,
//     throwOnError: true,
//   });
//   store.profile.followingCount -= 1;
//   store.save("profile");
//   cachedFirestore.clearCollectionCache(`profile/${store.user.uid}/following`);
//   cachedFirestore.clearCollectionCache("communityLevels");
//   await refreshProfile();
//     0,
//     currentFollowersCount - 1
//   );
// }

// async function isFollowedBy(uid, potentialFollowerUid) {
//   try {
//     const data = await cachedFirestore.getDocument({
//       reference: `profile/${uid}/followers/${potentialFollowerUid}`,
//     });
//     return data !== null;
//   } catch (error) {
//     catchErrorWithStack(error);
//     return false; // Assume not followed if there's an error
//   }
// }
